import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=410a9046&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=410a9046&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410a9046",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('410a9046')) {
      api.createRecord('410a9046', component.options)
    } else {
      api.reload('410a9046', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=410a9046&scoped=true&", function () {
      api.rerender('410a9046', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2AJLJdN0bSk2L/JS/comp/PopupBox.vue"
export default component.exports